import { CatalogBoardSummary, InactiveJiraMapping } from './jiraBoardTypes';

function normalizeProjectKey(projectKey: string): string {
  return projectKey.trim().toUpperCase();
}

export function buildCatalogBoardSources(
  summaries: CatalogBoardSummary[],
  inactiveMappings: InactiveJiraMapping[],
): CatalogBoardSummary[] {
  const byKey = new Map<string, CatalogBoardSummary>();

  for (const summary of summaries) {
    const projectKey = normalizeProjectKey(summary.projectKey);
    byKey.set(projectKey, {
      ...summary,
      projectKey,
      updatableEntityRefs: [...summary.updatableEntityRefs],
      entityRefs: [...summary.entityRefs],
      inheritedEntityRefs: [...(summary.inheritedEntityRefs ?? [])],
    });
  }

  for (const mapping of inactiveMappings) {
    for (const rawProjectKey of mapping.allProjectKeys) {
      const projectKey = normalizeProjectKey(rawProjectKey);
      const existing =
        byKey.get(projectKey) ??
        ({
          projectKey,
          catalogComponentCount: 0,
          entityRefs: [],
          updatableEntityRefs: [],
          inheritedEntityRefs: [],
        } satisfies CatalogBoardSummary);

      if (!existing.entityRefs.includes(mapping.entityRef)) {
        existing.entityRefs = [...existing.entityRefs, mapping.entityRef].sort();
        existing.catalogComponentCount = existing.entityRefs.length;
      }
      if (
        mapping.canUpdateMapping &&
        !existing.updatableEntityRefs.includes(mapping.entityRef)
      ) {
        existing.updatableEntityRefs = [...existing.updatableEntityRefs, mapping.entityRef].sort();
      }

      byKey.set(projectKey, existing);
    }
  }

  return Array.from(byKey.values()).sort((a, b) => a.projectKey.localeCompare(b.projectKey));
}
